import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {takeUntilDestroy} from 'take-until-destroy';
import {IntlServicePP} from '../../../intl/services/intl.service';
import {Language} from '../../../intl/interfaces/language';
import {AuthProviderService} from '../../../../app-auth/services/auth-provider.service';
import {Router} from '@angular/router';
import {PatientAccountPreferencesService} from '../../../../app-auth/services/patient.account.preferences.service';
import {PopupWindowService} from '../../../services/popup.window.service';
import {ContactPageComponent} from '../../../components/contact.us.page/contact-page.component';
import {ChangePasswordComponent} from "../../../change.password/components/change.password.component";
import {AppConfigurationService} from "../../../app-config/app-configuration.service";
import {map} from "rxjs/operators";
import {LogoutReason} from "../../../../app-auth/common/common.types";
import {AboutPageComponent} from "../../../components/about.page/about.page.component";

@Component({
  selector: 'app-language-selection',
  templateUrl: './language.selection.component.html',
  styleUrls: ['./language.selection.component.scss']
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  public languages: Language[] = [];
  public selectedLanguage: Language;
  public languageOptionsClosed = true;
  public showTheTooltip = false;
  @ViewChild('contactUsTitle', { static: true }) contactUsTitle: TemplateRef<any>;
  @ViewChild('aboutTitle', { static: true }) aboutTitle: TemplateRef<any>;
  @ViewChild('changePasswordTitle', { static: true }) changePasswordTitle: TemplateRef<any>;

  constructor(private intlServicePP: IntlServicePP,
              private authProviderService: AuthProviderService,
              private patientAccountPreferencesService: PatientAccountPreferencesService,
              private router: Router, public popupWindowService: PopupWindowService,
              private appConfigService: AppConfigurationService) {
  }

  public get isAuthenticated() {
    return this.authProviderService.isAuthenticated();
  }

  public get isInternalAuthentication() {
    return !this.appConfigService.Config.externalAuthentication;
  }

  public get firstName() {
    return this.authProviderService.currentPatient.firstName;
  }

  ngOnDestroy(): void { }

  ngOnInit() {
    this.intlServicePP.getUsedLanguageObservable().pipe(takeUntilDestroy(this)).subscribe(lang => {
      if (lang) {
        this.selectedLanguage = lang;
        this.languages = !this.languages.length ? this.intlServicePP.cachedLanguages
          .filter(l => (l.isActive && l.usage.toUpperCase() !== 'R') || l.isDefault)
          .sort((l1, l2) => l1.language >= l2.language ? 1 : -1) : this.languages;
      }
    });
  }

  public logoutClickHandler() {
      this.authProviderService.logout(LogoutReason.Manual);
  }

  public showContactUsPage() {
    this.popupWindowService
      .openPopupWindow(ContactPageComponent, this.contactUsTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10)
      .pipe(takeUntilDestroy(this))
      .subscribe((result) => {
        if (result === true) {
        }
      });
  }

  public showAboutPage() {
    this.popupWindowService
      .openPopupWindow(AboutPageComponent, this.aboutTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10)
      .pipe(takeUntilDestroy(this))
      .subscribe((result) => {
        if (result === true) {
        }
      });
  }

  public changePassword() {
    this.popupWindowService
      .openPopupWindow(ChangePasswordComponent, this.changePasswordTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10,
                  {userName: this.authProviderService.currentPatient.accountDetails.userName})
      .pipe(takeUntilDestroy(this))
      .subscribe((result) => {
      });
  }

  public languageSelectedHandler(lang: Language) {
    this.intlServicePP.setLanguage(lang, false, true);

    if (this.authProviderService.isAuthenticated()) {
      this.patientAccountPreferencesService.setDefaultAccountLanguage(lang.languageKey);
    }
  }

  public languagesToggleHandler(e) {
    this.languageOptionsClosed = !this.languageOptionsClosed;
    e.stopPropagation();
  }

  public setInitialState() {
    this.showTheTooltip = false;
    this.languageOptionsClosed = true;
  }
}
